import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../Photos/Brick & Clay Logo-01.png';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="sticky top-0 z-50 p-0 bg-zinc-900/80 backdrop-blur-sm border-b border-zinc-800">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <a href="/" className="block">
          <img src={logo} alt="Brick & Clay Logo" className="h-18 sm:h-24 md:h-30 lg:h-36 w-auto"/>
        </a>
        {/* Navigation */}
        <nav className="hidden md:flex space-x-8">
          <Link to="/products" className="nav-link text-sm uppercase tracking-widest font-medium text-neutral-200 hover:text-white transition-colors duration-300">Products</Link>
          <Link to="/about" className="nav-link text-sm uppercase tracking-widest font-medium text-neutral-200 hover:text-white transition-colors duration-300">About Us</Link>
          <Link to="/sustainability" className="nav-link text-sm uppercase tracking-widest font-medium text-neutral-200 hover:text-white transition-colors duration-300">Sustainability</Link>
          <Link to="/contact" className="nav-link text-sm uppercase tracking-widest font-medium text-neutral-200 hover:text-white transition-colors duration-300">Contact</Link>
        </nav>
        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-neutral-200 hover:text-white focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-zinc-800 px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <Link to="/products" onClick={() => setIsOpen(false)} className="block px-3 py-2 rounded-md text-base font-medium text-neutral-200 hover:text-white hover:bg-zinc-700">Products</Link>
          <Link to="/about" onClick={() => setIsOpen(false)} className="block px-3 py-2 rounded-md text-base font-medium text-neutral-200 hover:text-white hover:bg-zinc-700">About Us</Link>
          <Link to="/sustainability" onClick={() => setIsOpen(false)} className="block px-3 py-2 rounded-md text-base font-medium text-neutral-200 hover:text-white hover:bg-zinc-700">Sustainability</Link>
          <Link to="/contact" onClick={() => setIsOpen(false)} className="block px-3 py-2 rounded-md text-base font-medium text-neutral-200 hover:text-white hover:bg-zinc-700">Contact</Link>
        </div>
      )}
    </header>
  );
}

export default Header;